<div class="background">
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>